import { database } from "../utils/helper/firebase";
import { ref, onValue, off, DataSnapshot } from "firebase/database";

// In-memory map of path -> unsubscribe function
const subscriptions: Record<string, () => void> = {};

// LocalStorage key for persisting paths
const LOCAL_KEY = "firebase_subscribed_paths";

function saveSubscribedPaths() {
  localStorage.setItem(LOCAL_KEY, JSON.stringify(Object.keys(subscriptions)));
}

export function loadAndResubscribe(callback: (path: string) => void) {
  const paths = JSON.parse(localStorage.getItem(LOCAL_KEY) || "[]");
  paths.forEach((path: string) => callback(path));
}

/**
 * Subscribe to a Firebase Realtime Database path and store the unsubscribe function by path.
 * Also persists the path in localStorage for reload recovery.
 */
export function subscribeFirebase<T = any>(path: string, callback: (data: T | null, error?: string) => void) {
  if (!path) {
    callback(null, "No path provided");
    return;
  }
  // If already subscribed, unsubscribe first
  if (subscriptions[path]) {
    subscriptions[path]();
  }
  const dbRef = ref(database, path);
  const handler = onValue(
    dbRef,
    (snapshot: DataSnapshot) => {
      callback(snapshot.exists() ? (snapshot.val() as T) : null);
    },
    (err: Error) => {
      callback(null, err.message);
    }
  );
  subscriptions[path] = () => {
    off(dbRef, "value", handler);
    delete subscriptions[path];
    saveSubscribedPaths();
  };
  saveSubscribedPaths();
}

/**
 * Unsubscribe from a Firebase path by path string.
 */
export function unsubscribeFirebase(path: string) {
  if (subscriptions[path]) {
    subscriptions[path]();
  }
}
